var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram",
    clipPath: "url(#clip0_12_13974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9983 28.7994C22.951 28.7994 29.398 22.3524 29.398 14.3997C29.398 6.44696 22.951 0 14.9983 0C7.04559 0 0.598633 6.44696 0.598633 14.3997C0.598633 22.3524 7.04559 28.7994 14.9983 28.7994Z",
    fill: "url(#paint0_linear_12_13974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.1822 7.51042C22.7563 7.28644 23.3497 7.78874 23.2237 8.39184L20.6492 20.698C20.5289 21.2749 19.8511 21.5348 19.376 21.1857L15.4895 18.333L13.5085 20.3557C13.1604 20.7106 12.5601 20.5661 12.4108 20.0929L10.9815 15.5558L7.1503 14.4242C6.64704 14.2758 6.61796 13.5757 7.10569 13.3847L22.1822 7.51042ZM20.2923 10.241C20.46 10.0926 20.2651 9.83085 20.0751 9.94914L11.8057 15.0777C11.6602 15.1679 11.5933 15.3454 11.6447 15.5092L12.7724 20.4614C12.7947 20.537 12.9033 20.5263 12.913 20.4478L13.1651 16.6738C13.1748 16.5808 13.2194 16.4954 13.2893 16.4334L20.2923 10.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.075 9.94877C20.265 9.83048 20.4599 10.0923 20.2922 10.2406L13.2892 16.433C13.2194 16.4951 13.1748 16.5804 13.1651 16.6735L12.913 20.4474C12.9033 20.526 12.7947 20.5366 12.7724 20.461L11.6446 15.5089C11.5932 15.345 11.6601 15.1675 11.8056 15.0774L20.075 9.94877Z",
    fill: "#9EC2E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.8132 20.5127C12.6309 20.4477 12.4767 20.3023 12.4108 20.0928L10.9815 15.5557L7.1503 14.4241C6.64704 14.2757 6.61796 13.5756 7.10569 13.3846L22.1822 7.51036C22.5526 7.36586 22.9317 7.52392 23.1189 7.81681C23.0839 7.76348 23.0423 7.71404 22.9957 7.67039L12.7676 16.0202V16.3858L12.7113 16.3451L12.7676 18.6471V20.4934C12.7821 20.5002 12.7976 20.506 12.8131 20.5108V20.5127H12.8132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.4894 18.3328L13.5084 20.3556C13.4919 20.372 13.4745 20.3885 13.457 20.4031C13.4395 20.4177 13.422 20.4303 13.4036 20.4429C13.4027 20.4438 13.4027 20.4438 13.4027 20.4438C13.3658 20.4681 13.328 20.4884 13.2883 20.5049C13.2679 20.5127 13.2485 20.5204 13.2281 20.5253C13.1438 20.5505 13.0575 20.5573 12.9722 20.5485C12.9499 20.5466 12.9276 20.5427 12.9062 20.5389C12.9033 20.5389 12.9004 20.5379 12.8975 20.537C12.8762 20.5312 12.8548 20.5253 12.8335 20.5185C12.8267 20.5166 12.8199 20.5146 12.8131 20.5107L12.7676 18.6471V16.3857L15.4894 18.3328Z",
    fill: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.4578 20.4028C13.44 20.4176 13.4223 20.4314 13.4036 20.4442V20.4433C13.4223 20.4305 13.44 20.4176 13.4578 20.4028Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.4044 20.4429V20.4447C13.4044 20.4447 13.4044 20.4429 13.4026 20.4447C13.4026 20.4447 13.4026 20.4447 13.4044 20.4429Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.2881 20.5047C13.328 20.4881 13.3659 20.4677 13.4029 20.4434C13.3659 20.4676 13.327 20.4881 13.2881 20.5047Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.9719 20.5484C13.0573 20.5572 13.1435 20.5503 13.2279 20.5249C13.1668 20.5445 13.1038 20.5533 13.0408 20.5533C13.0214 20.5533 13.002 20.5523 12.9836 20.5503C12.9797 20.5504 12.9758 20.5504 12.9719 20.5484Z",
    fill: "#DADDE0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M12.9729 20.5484C12.9768 20.5504 12.9807 20.5504 12.9846 20.5504C12.9641 20.5494 12.9455 20.5464 12.926 20.5425C12.9416 20.5455 12.9572 20.5475 12.9729 20.5484Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M12.9729 20.5489C12.9573 20.5479 12.9416 20.5459 12.926 20.543C12.9192 20.542 12.9124 20.5411 12.9065 20.5391C12.928 20.543 12.9504 20.547 12.9729 20.5489Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M12.8333 20.5186C12.8547 20.5255 12.8763 20.5314 12.8977 20.5373C12.889 20.5354 12.8802 20.5334 12.8714 20.5314C12.8675 20.5304 12.8636 20.5295 12.8606 20.5275C12.8518 20.5255 12.842 20.5225 12.8333 20.5186Z",
    fill: "#DADDE0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M12.8711 20.5312C12.88 20.5332 12.8888 20.5352 12.8977 20.5371C12.8888 20.5362 12.88 20.5342 12.8711 20.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M12.8338 20.5186C12.8428 20.5226 12.8528 20.5256 12.8617 20.5276C12.8468 20.5246 12.8319 20.5196 12.8169 20.5137C12.8228 20.5156 12.8278 20.5177 12.8338 20.5186Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M12.8348 20.519C12.8286 20.518 12.8233 20.5159 12.8171 20.5138C12.8161 20.5148 12.814 20.5138 12.813 20.5128V20.5107C12.8202 20.5148 12.8275 20.5169 12.8348 20.519Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M12.7676 18.647L12.8136 20.5107C12.7979 20.5058 12.7822 20.5 12.7676 20.4932V18.647Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M12.7677 16.3859V18.6473L12.7109 16.3452L12.7677 16.3859Z",
    fill: "#DADDE0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M20.2922 10.2411L13.2892 16.4335C13.2194 16.4955 13.1748 16.5808 13.1651 16.6739L12.9134 20.4482C12.9038 20.5267 12.7951 20.5374 12.7718 20.4618L11.6446 15.5094C11.5932 15.3455 11.6601 15.168 11.8056 15.0779L20.075 9.94928C20.2651 9.83094 20.46 10.0928 20.2922 10.2411Z",
    fill: "#ADBCC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_13974",
    x1: 14.9983,
    y1: 0,
    x2: 14.9983,
    y2: 28.7994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AA5DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_13974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7994,
    height: 28.7994,
    fill: "white",
    transform: "translate(0.598633)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.7f438c05069c056b7b9e2425afcf79bc.svg";
export { ForwardRef as ReactComponent };